import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/componentImg/channel/tag_icon.png';

const _withScopeId = n => (_pushScopeId("data-v-c906e980"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  key: 0,
  class: "topic-view"
};

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "title"
}, "热议话题", -1));

const _hoisted_3 = {
  class: "tag-wrap"
};
const _hoisted_4 = ["onClick"];

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1));

import composition from '@/composition';
export default {
  props: {
    model: Object
  },

  setup(__props) {
    const props = __props;
    const {
      ref,
      request,
      openWebPage
    } = composition();
    let totals = [];
    const showMore = ref(false);
    const lists = ref([]);

    const getRandomArr = (arr, count) => {
      var newArr = [];

      for (var i = 0; i < count; i++) {
        if (arr.length > 0) {
          var idx = parseInt(Math.random() * arr.length);
          newArr.push(arr[idx]);
          arr.splice(idx, 1);
        }
      }

      return newArr;
    };

    const changeList = () => {
      lists.value = getRandomArr([...totals], 4);
    };

    request.getTimelineTags(props.model.id, {}).then(res => {
      totals = res.data;
      changeList();
      showMore.value = totals.length > 4 ? true : false;
    }); // 打开话题

    const openTag = item => {
      openWebPage('topic/index.html', item.id);
    };

    return (_ctx, _cache) => {
      return lists.value.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(lists.value, item => {
        return _openBlock(), _createElementBlock("div", {
          class: "btn",
          key: item.id,
          onClick: $event => openTag(item)
        }, [_hoisted_5, _createElementVNode("p", null, _toDisplayString(item.name), 1)], 8, _hoisted_4);
      }), 128))]), _withDirectives(_createElementVNode("div", {
        class: "change-btn",
        onClick: changeList
      }, "换一批", 512), [[_vShow, showMore.value]])])) : _createCommentVNode("", true);
    };
  }

};